import React from 'react';
import PropTypes from 'prop-types';
import { IconButton, Modal, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import ActionButton from '../../../components/ActionButton';
import CustomTable from '../components/CustomTable';
import { GetApp } from '@material-ui/icons';

const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: theme.spacing(4),
    backgroundColor: 'white',
    borderRadius: '6px',
    padding: '30px 0',
    boxShadow: theme.shadows[6],
    width: '80%',
    maxWidth: '960px',
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
  },
  centeredCellContent: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
  },
  tableWrapper: {
    width: '90%',
  },
  buttonWrapper: {
    width: '90%',
    display: 'flex',
    justifyContent: 'flex-end',
  },
}));

const ModalCronologiaAggiornamenti = ({
  downloadPdf,
  loading,
  onClose,
  open,
  storicoAggiornamenti,
}) => {
  const classes = useStyles();

  const columns = [
    {
      Header: 'ID',
      id: 'id',
      width: 180,
      accessor: (d) => d.id,
      Cell: ({ row }) => (
        <div className={classes.centeredCellContent}>{row.id}</div>
      ),
    },
    {
      Header: 'Data pubblicazione',
      id: 'dataPubblicazione',
      minWidth: 180,
      accessor: (d) => d.dataPubblicazione,
      Cell: ({ row }) => {
        const rawDate = row.dataPubblicazione;
        const cleanedDate = rawDate.split('.')[0] + 'Z'; // forza UTC correttamente
        const date = new Date(cleanedDate);
        const formattedDate = date.toLocaleDateString('it-IT', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          hour12: false,
        });

        return (
          <div className={classes.centeredCellContent}>{formattedDate}</div>
        );
      },
    },
    {
      Header: 'Versione',
      id: 'versione',
      width: 180,
      accessor: (d) => d.versione,
      Cell: ({ row }) => (
        <div className={classes.centeredCellContent}>{row.versione}</div>
      ),
    },
    {
      Header: 'Scarica',
      id: 'scarica',
      width: 180,
      filterable: false,
      accessor: (d) => d,
      Cell: ({ row }) => (
        <div className={classes.centeredCellContent}>
          <IconButton onClick={() => downloadPdf(row.id)}>
            <GetApp color="primary" />
          </IconButton>
        </div>
      ),
    },
  ];

  return (
    <Modal open={open} onClose={onClose} className={classes.modal}>
      <div className={classes.modalContainer}>
        <Typography variant="h5">Cronologia aggiornamenti</Typography>
        <div className={classes.tableWrapper}>
          <CustomTable
            columns={columns}
            records={storicoAggiornamenti}
            loading={loading}
            filterable={true}
            resizable={true}
            sortable={true}
            defaultPageSize={5}
            tableStyle={{ height: '426px' }}
          />
        </div>
        <div className={classes.buttonWrapper}>
          <ActionButton
            disabled={false}
            grayVersion={false}
            label="Chiudi"
            onClick={onClose}
          />
        </div>
      </div>
    </Modal>
  );
};

ModalCronologiaAggiornamenti.propTypes = {
  downloadPdf: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  storicoAggiornamenti: PropTypes.array.isRequired,
};

export default ModalCronologiaAggiornamenti;
